@if (physical || organisations) {
  <p>
    @if (type === 'physical') {
      <span class="status">
        <span class="text-muted"> Доступ ФЛ: </span>
        @if (!physical) {
          <span> Нет</span>
        }
        @if (physical && !physical.wizard_step) {
          <span> {{ (physical.is_user_active) ? 'Да' : 'Нет' }} </span>
        }
        @if (physical && physical.wizard_step) {
          <span>Только мастер ({{ physical.wizard_step }}/5)</span>
        }
      </span>
    }
    @if (type === 'organisation') {
      <span class="status">
        <span class="text-muted"> Доступ ФЛ (Р-ль): </span>
        @if (!physical) {
          <span> Нет</span>
        }
        @if (physical && !physical.wizard_step) {
          <span> {{ (physical.is_user_active) ? 'Да' : 'Нет' }} </span>
        }
        @if (physical && physical.wizard_step) {
          <span>Только мастер ({{ physical.wizard_step }}/5)</span>
        }
      </span>
    }
    @if (!organisations || organisations.length == 0) {
      <span>
        <span class="text-muted"> Доступ ЮЛ: </span>
        <span>Нет организации </span>
      </span>
    }
    @if (organisations && organisations.length > 0) {
      <span class="status">
        <span class="text-muted"> Доступ ЮЛ: </span>
        @for (org of organisations; track org) {
          <span>
            @if (organisations.length > 1) {
              <span> {{ org.caption }} - </span>
            }
            @if (org.subagent) {
              <span>{{ org.status }}
                <span>
                  (<a href="/attraction/lead-info/{{org.lead_id}}"
                  (click)="goBack.newLink('/attraction/lead-info/' + org.lead_id, $event)"
                  >
                  {{ org.lead_stage }}
                </a>
                <popover-content
                  #popoverInfo
                  [title]="'Комментарий' "
                  [placement]="'right'"
                  [closeOnClickOutside]="false"
                  [closeOnMouseOutside]="true">
                  <p>{{org.lead_comment}}</p>
                </popover-content>
                @if (org.lead_comment) {
                  <a [popover]="popoverInfo" href="javascript:void(0)">
                    <i class="fa fa-comment"></i>
                  </a>
                }
                )
              </span>
            </span>
          }
          @if (!org.subagent) {
            <span>Не является субагентом </span>
          }
        </span>
      }
    </span>
  }
</p>
}
